import React, { useState, useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { API_BASE_URL } from '../config/config.js'; 

function DestinationSlide({ dest, index }) {
  const slideSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
    delay: 500 + index * 200, // Stagger by 200ms per slide
    config: { duration: 800 },
  });

  return (
    <animated.div className="swiper-slide" style={slideSpring}>
      <div className="destination-card-items">
        <div className="destination-thumb">
          <img src={dest.image || './assets/img/header/home-2.jpg'} alt={dest.name} />
          <div className="ratting">
            <i className="fa-solid fa-star"></i>
            <span>{dest.rating}</span>
          </div>
          <div className="heart">
            <i className="fa-solid fa-heart"></i>
          </div>
        </div>
        <div className="destination-content">
          <h4>
            <a href={dest.detailsLink}>{dest.name}</a>
          </h4>
          <span className="place">
            <i className="fa-solid fa-location-dot"></i> {dest.locations}
          </span>
          <h5>
            ${dest.price}<span>/Person</span>
          </h5>
          <div className="booking">
            <span>
              <i className="fa-solid fa-clock"></i> {dest.duration} days
            </span>
            <a href={dest.detailsLink} className="theme-btn">
              Read More
              <img src="assets/img/icon/theme-arrow.svg" alt="arrow" />
            </a>
          </div>
        </div>
      </div>
    </animated.div>
  );
}

function InternationalDestinations() {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Define hooks at the top level
  const subTitleSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
    config: { duration: 800 },
  });

  const titleSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
    delay: 300,
    config: { duration: 800 },
  });

  useEffect(() => {
    const fetchInternationalPackages = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/international-packages/tour-packages`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setDestinations(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInternationalPackages();
  }, []);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5 text-danger">Error: {error}</div>;

  return (
    <section className="destination-section section-padding fix">
      <div className="container">
        <div className="section-title text-center">
          <animated.span className="sub-title" style={subTitleSpring}>
            Best Recommended Places
          </animated.span>
          <animated.h2 className="wow fadeInUp" style={titleSpring}>
            Discover the World's Treasures <br />
            with Fayah Travels
          </animated.h2>
        </div>
        <div className="swiper destination-slider">
          <div className="swiper-wrapper">
            {destinations.map((dest, index) => (
              <DestinationSlide key={index} dest={dest} index={index} />
            ))}
          </div>
          {/* Ensure swiper dots are visible */}
          <div className="swiper-dot4 mt-5">
            <div className="dot"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InternationalDestinations;